import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function BestSellers() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api
      .get("/products", { params: { bestseller: true } })
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]));
  }, []);

  return (
    <section className="py-24 md:py-32 bg-[#F8F5F0]" data-testid="bestsellers-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-end justify-between mb-14 gap-6">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <span className="divider-gold" />
              <span className="overline">Coveted by Editors</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl tracking-tighter font-light leading-[1.02]">
              Best <em className="gold-text not-italic">Sellers</em>
            </h2>
          </div>
          <Link to="/shop" className="overline hover:text-[#C9A961] transition-colors" data-testid="bestsellers-view-all">
            View All →
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8" data-testid="bestsellers-grid">
          {products.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.05 }}
            >
              <ProductCard product={p} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
